import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, MenuItem, FormControl, Select, Button, TextField, Checkbox, OutlinedInput } from '@mui/material';
import mainPath from '../utils/path';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme)=>({
    itm: {
      borderBottom: '1px solid #D3D3D3',
      display: 'flex',
  
      [theme.breakpoints.down(1025)]: {
        display:'none'
      } 
    },
    mobileItmBox:{
      display:'none',
  
      [theme.breakpoints.down(1025)]: {
        display:'block',
        borderBottom: '1px solid #D3D3D3',
        display: 'flex',
      } 
    },
    checkBox: {
      borderRight: '1px solid #D3D3D3',
      width: '5%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    oneBox: {
      borderRight: '1px solid #D3D3D3',
      width: '8%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      wordBreak:'break-all',
      overflow:'hidden',
  
      [theme.breakpoints.down(1025)]: {
        width: '15%',
      } 
    },
    flexBox:{
      display: 'flex',
      flex:'1',
      width: '100%',
      justifyContent: 'center',
      wordBreak:'break-all',
  
      [theme.breakpoints.down(1025)]: {
        width: '31%',
      } 
    },
    flexOutBox:{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      width:'44%',
      overflow:'hidden',
    },
    twoBox: {
      borderRight: '1px solid #D3D3D3',
      borderLeft: '1px solid #D3D3D3',
      display: 'flex',
      flexDirection: 'column',
      width: '10%',
      wordBreak:'break-all',
  
      [theme.breakpoints.down(1025)]: {
        width: '31%',
      },
      [theme.breakpoints.down(424)]: {
        border:'none',
      },  
    },
    twoBox3: {
      borderRight: '1px solid #D3D3D3',
      borderLeft: '1px solid #D3D3D3',
      display: 'flex',
      flexDirection: 'column',
      width: '10%',
      wordBreak:'break-all',
  
      [theme.breakpoints.down(1025)]: {
        width: '50%',
      },
    },
    threeBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '8%',
      wordBreak:'break-all',
    },
    imgBox:{
      borderRight: '1px solid #D3D3D3',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '15%',
      wordBreak:'break-all',
    },
    inBox1: {
      borderBottom:'1px solid #D3D3D3',
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(1025)]: {
        borderBottom: 'none',
      },
    },
    inBox2: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderBottom:'1px solid #D3D3D3',
    },
    inBox3: {
      display:'flex',
      flex:1,
      justifyContent:'center',
      alignItems:'center',
    },
  
  }));


const ItemConfigList = ({
    checks, 
    setChecks, 
    type1, 
    type2, 
    type3, 
    data, 
    setData,
    colorList,
    picList,
    setAdmin
}) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    let navigate = useNavigate();

    
  return (
    <>
    {data.map((item, index) => 
                  <div 
                    style={{
                      backgroundColor: index % 2 == 0 && '#F2F2F2'
                    }}
                    key={index}
                  >
                    <ItmItem
                      checks={checks}
                      setChecks={setChecks} 
                      type1={type1} 
                      type2={type2} 
                      type3={type3} 
                      data={data} 
                      setData={setData}
                      colorList={colorList}
                      picList={picList}
                      itId={item['it_id']}
                      caId={item['ca_id']}
                      caId2={item['ca_id2']}
                      caId3={item['ca_id3']}
                      itImg1={item['it_img1']} 
                      itName={item['it_name']} 
                      itPrice={item['it_price']} 
                      itStockQty={item['it_stock_qty']} 
                      itUse={item['it_use']} 
                      itMaker={item['it_maker']}
                      itHit={item['it_hit']} 
                      picId={item['pic_id']} 
                      colorId={item['color_id']}
                      itType1={item['it_type1']}
                      itType2={item['it_type2']}
                      itType3={item['it_type3']}
                      itType4={item['it_type4']}
                      itType5={item['it_type5']}
                      classes={classes}
                      navigate={navigate}
                      setAdmin={setAdmin}
                    />
                  </div>
            )}
    </>
  )
}

const ItmItem = memo(({
    checks, 
    setChecks, 
    type1, 
    type2, 
    type3, 
    data, 
    setData,
    colorList,
    picList,
    itId,
    caId,
    caId2,
    caId3,
    itImg1, 
    itName, 
    itPrice, 
    itStockQty, 
    itUse, 
    itMaker,
    itHit, 
    picId, 
    colorId,
    itType1,
    itType2,
    itType3,
    itType4,
    itType5,
    classes,
    navigate,
    setAdmin
}) => {
  const idx = data.findIndex((item) => item['it_id'] === itId)
  
  return (
      <div>
        <div className={classes.itm}>
            <CheckCompo 
              classes={classes} 
              checks={checks}  
              setChecks={setChecks}  
              itId={itId} 
            />
            
            <div className={classes.imgBox}>
              <img
                style={{width: '170px', height: '170px', margin: 5, }}
                src={`${mainPath}/media/data/item/${itImg1}`} 
                onClick={() => {
                  setAdmin(false)
                  navigate("/ShopMain/ShopItemAll", {
                    state: { itId: itId }
                  });
                }}
              />
            </div>
            <div className={classes.flexOutBox}>
                <div className={classes.flexBox}>
                  <Type1Compo 
                    classes={classes} 
                    setData={setData}  
                    caId={caId} 
                    type1={type1} 
                    idx={idx} 
                  />
                  <Type2Compo 
                    classes={classes} 
                    setData={setData}  
                    caId2={caId2} 
                    type2={type2} 
                    idx={idx} 
                  />
                  <Type3Compo 
                    classes={classes} 
                    setData={setData}  
                    caId3={caId3} 
                    type3={type3} 
                    idx={idx} 
                  />
                  <ColorCompo 
                    classes={classes} 
                    setData={setData}  
                    colorId={colorId} 
                    colorList={colorList} 
                    idx={idx} 
                  />
                </div>
                <div 
                  className={classes.inBox3}
                  style={{ width:'90%'}}
                >
                  <NameCompo 
                    classes={classes} 
                    setData={setData}  
                    itName={itName} 
                    idx={idx} 
                  />
                </div>
              </div>
            <div className={classes.twoBox}>
              <PriceCompo 
                classes={classes}  
                setData={setData}  
                itPrice={itPrice} 
                idx={idx} 
              />
              <QtyCompo 
                classes={classes}   
                setData={setData}  
                itStockQty={itStockQty} 
                idx={idx} 
              />
              <UseCompo 
                classes={classes}  
                setData={setData}  
                itUse={itUse} 
                idx={idx} 
              />
            </div>
            <div className={classes.twoBox}>
              <PicCompo 
                classes={classes} 
                setData={setData}  
                picId={picId} 
                picList={picList} 
                idx={idx} 
              />
              <MakerCompo 
                classes={classes} 
                setData={setData}  
                itMaker={itMaker} 
                idx={idx} 
              />
              <RecoCompo 
                classes={classes}  
                setData={setData} 
                idx={idx} 
                itType1={itType1}
                itType2={itType2}
                itType3={itType3}
                itType4={itType4}
                itType5={itType5}
              />
            </div>
            <div className={classes.oneBox}>
              <Button 
                variant="text"
                onClick={() => {
                  navigate("/DashboardMain/itemEdit", {
                    state: { it_id: itId }
                  });
                }}
              >
                수정
              </Button>
            </div>
            <div 
              className={classes.threeBox}>
              {itHit}
            </div>
                      

        </div>

        <div className={classes.mobileItmBox}>
          <CheckCompo 
            classes={classes} 
            checks={checks}  
            setChecks={setChecks}  
            itId={itId} 
          />

          <div className={classes.twoBox3}>
              <div className={classes.inBox1}>
                <img
                  style={{width: '50px', height: '50px', margin: 5, }}
                  src={`${mainPath}/media/data/item/${itImg1}`} 
                  onClick={() => {
                    setAdmin(false)
                    navigate("/ShopMain/ShopItemAll", {
                      state: { itId: itId }
                    });
                  }}
                />
              </div>
              <div className={classes.inBox1}>
                <TextField 
                  value={itName || ''} 
                  onChange={(e) => {
                    let dataList = [...data]
                    dataList[idx]['it_name'] = e.target.value 
                    setData(dataList)
                  }}  
                  size='small' 
                  sx={{ m:2 }}
                  hiddenlabel="true" 
                  variant="outlined" 
                />
              </div>


          </div>
            <div className={classes.twoBox}>
              <PriceCompo 
                classes={classes}  
                setData={setData}  
                itPrice={itPrice} 
                idx={idx} 
              />
              <QtyCompo 
                classes={classes}   
                setData={setData}  
                itStockQty={itStockQty} 
                idx={idx} 
              />
              <UseCompo 
                classes={classes}  
                setData={setData}  
                itUse={itUse} 
                idx={idx} 
              />
            </div>
            <div className={classes.oneBox}>
              <Button 
                variant="text"
                onClick={() => {
                  navigate("/DashboardMain/itemEdit", {
                    state: { it_id: itId }
                  });
                }}
              >
                수정
              </Button>
            </div>

        </div>

      </div>
  );
})


const CheckCompo = memo(({classes, checks, setChecks, itId}) => { 
  return (
    <div className={classes.checkBox}>
      <Checkbox 
        checked={checks.includes(itId)}
        onChange={() => {
          !checks.includes(itId) ?
          setChecks([...checks, itId]) : 
          setChecks([...checks.filter((item) => item !==  itId)])
        }}
      />
    </div>
  )
})

const Type1Compo = memo(({classes, setData, caId, type1, idx}) => { 
  return (
    <div className={classes.inBox1}>
      <FormControl 
        size="small"
        sx={{ width: '100%' }}
      >
        <Select
          labelId="select-small"
          id="select-small"
          sx={{ m:2 }}
          style={{width:'90%'}}
          value={caId || ''}
          onChange={(e) => {
            const input = e.target.value;
            setData((prevArr) => {
              return [
                ...prevArr.slice(0, idx),
                { 
                  ca_id: input,
                  ca_id2: prevArr[idx].ca_id2,
                  ca_id3: prevArr[idx].ca_id3,
                  color_id: prevArr[idx].color_id,
                  it_hit: prevArr[idx].it_hit,
                  it_id: prevArr[idx].it_id,
                  it_img1: prevArr[idx].it_img1,
                  it_maker: prevArr[idx].it_maker,
                  it_name: prevArr[idx].it_name,
                  it_point: prevArr[idx].it_point,
                  it_price: prevArr[idx].it_price,
                  it_soldout: prevArr[idx].it_soldout,
                  it_stock_qty: prevArr[idx].it_stock_qty,
                  it_type1: prevArr[idx].it_type1,
                  it_type2: prevArr[idx].it_type2,
                  it_type3: prevArr[idx].it_type3,
                  it_type4: prevArr[idx].it_type4,
                  it_type5: prevArr[idx].it_type5,
                  it_use: prevArr[idx].it_use,
                  pic_id: prevArr[idx].pic_id,
                },
                ...prevArr.slice(idx + 1, prevArr.length)
              ];
            });
          }}
        >
          {type1.length > 0 && type1.map((value, idx) => 
                        <MenuItem key={idx} value={value['ca_id']}>
                          {`${value['ca_name']}(${value['ca_id']})`}
                        </MenuItem>
          )}
        
        </Select>
      </FormControl>
    </div>
  )
})

const Type2Compo = memo(({classes, setData, caId2, type2, idx}) => { 
  return (
    <div 
      className={classes.inBox1}>
      <FormControl size="small"  sx={{ width: '100%' }}>
        <Select
          labelId="select-small"
          id="select-small"
          sx={{ m:2 }}
          style={{width:'90%'}}
          value={caId2 || ''}
          onChange={(e) => {
            const input = e.target.value;
            setData((prevArr) => {
              return [
                ...prevArr.slice(0, idx),
                { 
                  ca_id: prevArr[idx].ca_id,
                  ca_id2: input,
                  ca_id3: prevArr[idx].ca_id3,
                  color_id: prevArr[idx].color_id,
                  it_hit: prevArr[idx].it_hit,
                  it_id: prevArr[idx].it_id,
                  it_img1: prevArr[idx].it_img1,
                  it_maker: prevArr[idx].it_maker,
                  it_name: prevArr[idx].it_name,
                  it_point: prevArr[idx].it_point,
                  it_price: prevArr[idx].it_price,
                  it_soldout: prevArr[idx].it_soldout,
                  it_stock_qty: prevArr[idx].it_stock_qty,
                  it_type1: prevArr[idx].it_type1,
                  it_type2: prevArr[idx].it_type2,
                  it_type3: prevArr[idx].it_type3,
                  it_type4: prevArr[idx].it_type4,
                  it_type5: prevArr[idx].it_type5,
                  it_use: prevArr[idx].it_use,
                  pic_id: prevArr[idx].pic_id,
                },
                ...prevArr.slice(idx + 1, prevArr.length)
              ];
            });
          }}
        >
          {type2.length > 0 && type2.map((value, idx) => 
                          <MenuItem key={idx} value={value['ca_id']}>{`${value['ca_name']}(${value['ca_id']})`}</MenuItem>
          )}
        
        </Select>
      </FormControl>
    </div>
  )
})

const Type3Compo = memo(({classes, setData, caId3, type3, idx}) => { 
  return (
    <div className={classes.inBox1}>
      <FormControl size="small">
        <Select
          labelId="select-small"
          id="select-small"
          sx={{ m:2 }}
          style={{width:100}}
          value={caId3 || ''}
          onChange={(e) => {
            const input = e.target.value;
            setData((prevArr) => {
              return [
                ...prevArr.slice(0, idx),
                { 
                  ca_id: prevArr[idx].ca_id,
                  ca_id2: prevArr[idx].ca_id2,
                  ca_id3: input,
                  color_id: prevArr[idx].color_id,
                  it_hit: prevArr[idx].it_hit,
                  it_id: prevArr[idx].it_id,
                  it_img1: prevArr[idx].it_img1,
                  it_maker: prevArr[idx].it_maker,
                  it_name: prevArr[idx].it_name,
                  it_point: prevArr[idx].it_point,
                  it_price: prevArr[idx].it_price,
                  it_soldout: prevArr[idx].it_soldout,
                  it_stock_qty: prevArr[idx].it_stock_qty,
                  it_type1: prevArr[idx].it_type1,
                  it_type2: prevArr[idx].it_type2,
                  it_type3: prevArr[idx].it_type3,
                  it_type4: prevArr[idx].it_type4,
                  it_type5: prevArr[idx].it_type5,
                  it_use: prevArr[idx].it_use,
                  pic_id: prevArr[idx].pic_id,
                },
                ...prevArr.slice(idx + 1, prevArr.length)
              ];
            });
          }}
        >
          {type3.length > 0 && type3.map((value, idx) => 
                          <MenuItem key={idx} value={value['ca_id']}>{`${value['ca_name']}(${value['ca_id']})`}</MenuItem>
          )}
        
        </Select>
      </FormControl>
    </div>
  )
})

const NameCompo = memo(({classes, setData, itName, idx}) => { 
  return (
    <div className={classes.inBox3}>
      <TextField 
        value={itName || ''} 
        onChange={(e) => {
          const input = e.target.value;
          setData((prevArr) => {
            return [
              ...prevArr.slice(0, idx),
              { 
                ca_id: prevArr[idx].ca_id,
                ca_id2: prevArr[idx].ca_id2,
                ca_id3: prevArr[idx].ca_id3,
                color_id: prevArr[idx].color_id,
                it_hit: prevArr[idx].it_hit,
                it_id: prevArr[idx].it_id,
                it_img1: prevArr[idx].it_img1,
                it_maker: prevArr[idx].it_maker,
                it_name: input,
                it_point: prevArr[idx].it_point,
                it_price: prevArr[idx].it_price,
                it_soldout: prevArr[idx].it_soldout,
                it_stock_qty: prevArr[idx].it_stock_qty,
                it_type1: prevArr[idx].it_type1,
                it_type2: prevArr[idx].it_type2,
                it_type3: prevArr[idx].it_type3,
                it_type4: prevArr[idx].it_type4,
                it_type5: prevArr[idx].it_type5,
                it_use: prevArr[idx].it_use,
                pic_id: prevArr[idx].pic_id,
              },
              ...prevArr.slice(idx + 1, prevArr.length)
            ];
          });
        }}
        style={{width:'100%'}}
        size='small' 
        sx={{"& .MuiInputBase-root": {height: 25}}} 
        hiddenlabel="true" 
        variant="outlined" 
      />
    </div>
  )
})

const PriceCompo = memo(({classes, setData, itPrice, idx}) => { 
  return (
    <div className={classes.inBox1}>
      <TextField 
        value={itPrice || 0} 
        onChange={(e) => {
          const input = parseInt(e.target.value);
          setData((prevArr) => {
            return [
              ...prevArr.slice(0, idx),
              { 
                ca_id: prevArr[idx].ca_id,
                ca_id2: prevArr[idx].ca_id2,
                ca_id3: prevArr[idx].ca_id3,
                color_id: prevArr[idx].color_id,
                it_hit: prevArr[idx].it_hit,
                it_id: prevArr[idx].it_id,
                it_img1: prevArr[idx].it_img1,
                it_maker: prevArr[idx].it_maker,
                it_name: prevArr[idx].it_name,
                it_point: prevArr[idx].it_point,
                it_price: input,
                it_soldout: prevArr[idx].it_soldout,
                it_stock_qty: prevArr[idx].it_stock_qty,
                it_type1: prevArr[idx].it_type1,
                it_type2: prevArr[idx].it_type2,
                it_type3: prevArr[idx].it_type3,
                it_type4: prevArr[idx].it_type4,
                it_type5: prevArr[idx].it_type5,
                it_use: prevArr[idx].it_use,
                pic_id: prevArr[idx].pic_id,
              },
              ...prevArr.slice(idx + 1, prevArr.length)
            ];
          });
        }}
        size='small' 
        style={{width:100}}
        sx={{"& .MuiInputBase-root": {height: 25}}} 
        hiddenlabel="true" 
        variant="outlined" 
      />
    </div>
  )
})

const QtyCompo = memo(({classes, setData, itStockQty, idx}) => { 
  return (
    <div className={classes.inBox1}>
      <TextField 
        value={itStockQty || 0} 
        onChange={(e) => {
          const input = e.target.value;
          setData((prevArr) => {
            return [
              ...prevArr.slice(0, idx),
              { 
                ca_id: prevArr[idx].ca_id,
                ca_id2: prevArr[idx].ca_id2,
                ca_id3: prevArr[idx].ca_id3,
                color_id: prevArr[idx].color_id,
                it_hit: prevArr[idx].it_hit,
                it_id: prevArr[idx].it_id,
                it_img1: prevArr[idx].it_img1,
                it_maker: prevArr[idx].it_maker,
                it_name: prevArr[idx].it_name,
                it_point: prevArr[idx].it_point,
                it_price: prevArr[idx].it_price,
                it_soldout: prevArr[idx].it_soldout,
                it_stock_qty: input,
                it_type1: prevArr[idx].it_type1,
                it_type2: prevArr[idx].it_type2,
                it_type3: prevArr[idx].it_type3,
                it_type4: prevArr[idx].it_type4,
                it_type5: prevArr[idx].it_type5,
                it_use: prevArr[idx].it_use,
                pic_id: prevArr[idx].pic_id,
              },
              ...prevArr.slice(idx + 1, prevArr.length)
            ];
          });
        }}
        type='number'
        size='small' 
        sx={{"& .MuiInputBase-root": {height: 25}}} 
        style={{width:100}}
        hiddenlabel="true" 
        variant="outlined" 
      />
    </div>
  )
})

const ColorCompo = memo(({classes, setData, colorId, colorList, idx}) => { 
  return (
    <div 
      className={classes.inBox2}
    >
      <FormControl size="small">
        <Select
          labelId="select-small"
          id="select-small"
          sx={{ m:2 }}
          style={{width:100}}
          value={colorId}
          onChange={(e) => {
            const input = e.target.value;
            setData((prevArr) => {
              return [
                ...prevArr.slice(0, idx),
                { 
                  ca_id: prevArr[idx].ca_id,
                  ca_id2: prevArr[idx].ca_id2,
                  ca_id3: prevArr[idx].ca_id3,
                  color_id: input,
                  it_hit: prevArr[idx].it_hit,
                  it_id: prevArr[idx].it_id,
                  it_img1: prevArr[idx].it_img1,
                  it_maker: prevArr[idx].it_maker,
                  it_name: prevArr[idx].it_name,
                  it_point: prevArr[idx].it_point,
                  it_price: prevArr[idx].it_price,
                  it_soldout: prevArr[idx].it_soldout,
                  it_stock_qty: prevArr[idx].it_stock_qty,
                  it_type1: prevArr[idx].it_type1,
                  it_type2: prevArr[idx].it_type2,
                  it_type3: prevArr[idx].it_type3,
                  it_type4: prevArr[idx].it_type4,
                  it_type5: prevArr[idx].it_type5,
                  it_use: prevArr[idx].it_use,
                  pic_id: prevArr[idx].pic_id,
                },
                ...prevArr.slice(idx + 1, prevArr.length)
              ];
            });
          }}
        >
          {colorList.length > 0 && colorList.map((value, idx) => 
                              <MenuItem key={idx} value={value['color_id']}>{value['color_name']}</MenuItem>
          )}
        
        </Select>
      </FormControl>
    </div>
  )
})

const UseCompo = memo(({classes, setData, itUse, idx}) => { 
  return (
    <div className={classes.inBox2}>
      <Checkbox
        checked={itUse === 1 ? true : false}
        onChange={() => {
          setData((prevArr) => {
            return [
              ...prevArr.slice(0, idx),
              { 
                ca_id: prevArr[idx].ca_id,
                ca_id2: prevArr[idx].ca_id2,
                ca_id3: prevArr[idx].ca_id3,
                color_id: prevArr[idx].color_id,
                it_hit: prevArr[idx].it_hit,
                it_id: prevArr[idx].it_id,
                it_img1: prevArr[idx].it_img1,
                it_maker: prevArr[idx].it_maker,
                it_name: prevArr[idx].it_name,
                it_point: prevArr[idx].it_point,
                it_price: prevArr[idx].it_price,
                it_soldout: prevArr[idx].it_soldout,
                it_stock_qty: prevArr[idx].it_stock_qty,
                it_type1: prevArr[idx].it_type1,
                it_type2: prevArr[idx].it_type2,
                it_type3: prevArr[idx].it_type3,
                it_type4: prevArr[idx].it_type4,
                it_type5: prevArr[idx].it_type5,
                it_use: itUse === 0 ? 1 : 0,
                pic_id: prevArr[idx].pic_id,
              },
              ...prevArr.slice(idx + 1, prevArr.length)
            ];
          });
        }}
      />
    </div>
  )
})

const MakerCompo = memo(({classes, setData, itMaker, idx}) => { 
  return (
    <div className={classes.inBox1}>
      <TextField 
        value={itMaker || ''} 
        onChange={(e) => {
          const input = e.target.value;
          setData((prevArr) => {
            return [
              ...prevArr.slice(0, idx),
              { 
                ca_id: prevArr[idx].ca_id,
                ca_id2: prevArr[idx].ca_id2,
                ca_id3: prevArr[idx].ca_id3,
                color_id: prevArr[idx].color_id,
                it_hit: prevArr[idx].it_hit,
                it_id: prevArr[idx].it_id,
                it_img1: prevArr[idx].it_img1,
                it_maker: input,
                it_name: prevArr[idx].it_name,
                it_point: prevArr[idx].it_point,
                it_price: prevArr[idx].it_price,
                it_soldout: prevArr[idx].it_soldout,
                it_stock_qty: prevArr[idx].it_stock_qty,
                it_type1: prevArr[idx].it_type1,
                it_type2: prevArr[idx].it_type2,
                it_type3: prevArr[idx].it_type3,
                it_type4: prevArr[idx].it_type4,
                it_type5: prevArr[idx].it_type5,
                it_use: prevArr[idx].it_use,
                pic_id: prevArr[idx].pic_id,
              },
              ...prevArr.slice(idx + 1, prevArr.length)
            ];
          });
        }}
        size='small' 
        sx={{"& .MuiInputBase-root": {height: 25}}} 
        style={{width:100}}
        hiddenlabel="true" 
        variant="outlined" 
      />
    </div>
  )
})

const RecoCompo = memo(({
  classes, 
  setData, 
  idx, 
  itType1,
  itType2,
  itType3,
  itType4,
  itType5
  }) => { 

  return (
    <div className={classes.inBox2}>
      <FormControl 
        size="small"
        >
        <Select
          labelId="select-small"
          id="select-small"
          multiple
          style={{width:100}}
          sx={{"& .MuiInputBase-root": {height: 25}}} 
          input={<OutlinedInput label="Tag" />}
          value={[]}
          onChange={(e) => {
            const input = e.target.value;
            setData((prevArr) => {
              return [
                ...prevArr.slice(0, idx),
                { 
                  ca_id: prevArr[idx].ca_id,
                  ca_id2: prevArr[idx].ca_id2,
                  ca_id3: prevArr[idx].ca_id3,
                  color_id: prevArr[idx].color_id,
                  it_hit: prevArr[idx].it_hit,
                  it_id: prevArr[idx].it_id,
                  it_img1: prevArr[idx].it_img1,
                  it_maker: prevArr[idx].it_maker,
                  it_name: prevArr[idx].it_name,
                  it_point: prevArr[idx].it_point,
                  it_price: prevArr[idx].it_price,
                  it_soldout: prevArr[idx].it_soldout,
                  it_stock_qty: prevArr[idx].it_stock_qty,
                  it_type1: prevArr[idx].it_type1,
                  it_type2: prevArr[idx].it_type2,
                  it_type3: prevArr[idx].it_type3,
                  it_type4: prevArr[idx].it_type4,
                  it_type5: prevArr[idx].it_type5,
                  it_use: prevArr[idx].it_use,
                  pic_id: prevArr[idx].pic_id,
                  [e.target.value[0]]: prevArr[idx][e.target.value[0]] === 1 ? 0 : 1
                },
                ...prevArr.slice(idx + 1, prevArr.length)
              ];
            });
          }}
        >
          <MenuItem value={'it_type1'}>
            <Checkbox checked={itType1 === 1} />
            히트
          </MenuItem>
          <MenuItem value={'it_type2'}>
            <Checkbox checked={itType2 === 1} />
            추천
          </MenuItem>
          <MenuItem value={'it_type3'}>
            <Checkbox checked={itType3 === 1} />
            신상품
          </MenuItem>
          <MenuItem value={'it_type4'}>
            <Checkbox checked={itType4 === 1} />
            인기
          </MenuItem>
          <MenuItem value={'it_type5'}>
            <Checkbox checked={itType5 === 1} />
            할인
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  )
})

const PicCompo = memo(({classes, setData, picId, picList, idx}) => { 
  return (
    <div 
      className={classes.inBox1}
    >

      <FormControl size="small">
        <Select
          labelId="select-small"
          id="select-small"
          style={{width:100}}
          sx={{"& .MuiInputBase-root": {height: 25}}} 
          value={picId}
          onChange={(e) => {
            const input = e.target.value;
            setData((prevArr) => {
              return [
                ...prevArr.slice(0, idx),
                { 
                  ca_id: prevArr[idx].ca_id,
                  ca_id2: prevArr[idx].ca_id2,
                  ca_id3: prevArr[idx].ca_id3,
                  color_id: prevArr[idx].color_id,
                  it_hit: prevArr[idx].it_hit,
                  it_id: prevArr[idx].it_id,
                  it_img1: prevArr[idx].it_img1,
                  it_maker: prevArr[idx].it_maker,
                  it_name: prevArr[idx].it_name,
                  it_point: prevArr[idx].it_point,
                  it_price: prevArr[idx].it_price,
                  it_soldout: prevArr[idx].it_soldout,
                  it_stock_qty: prevArr[idx].it_stock_qty,
                  it_type1: prevArr[idx].it_type1,
                  it_type2: prevArr[idx].it_type2,
                  it_type3: prevArr[idx].it_type3,
                  it_type4: prevArr[idx].it_type4,
                  it_type5: prevArr[idx].it_type5,
                  it_use: prevArr[idx].it_use,
                  pic_id: input,
                },
                ...prevArr.slice(idx + 1, prevArr.length)
              ];
            });
          }}
        >
          {picList.length > 0 && picList.map((value, idx) => 
                              <MenuItem key={idx} value={value['pic_id']}>{value['pic_name']}</MenuItem>
          )}
        
        </Select>
      </FormControl>
    </div>
  )
})





export default memo(ItemConfigList)
